import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon, CompletedSVGpath, CircleRingSVGpath } from '@skatteetaten/ds-icons';
import { g as getChipDefaultSize } from '../defaults.esm.js';
import './styles.css';


const getChipsToggleDefaultShowCheckmark = ()=>true;
const getChipsToggleDefaultIsSelected = ()=>false;

var styles = {
    "toggleChip": "ChipsToggle-module_toggleChip__pn3YG",
    "toggleChip_small": "ChipsToggle-module_toggleChip_small__ZleSB",
    "toggleChip_withCheckmark": "ChipsToggle-module_toggleChip_withCheckmark__pnDgE",
    "icon": "ChipsToggle-module_icon__PH2VL"
};

const ChipsToggle = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, size = getChipDefaultSize(), disabled, isSelected = getChipsToggleDefaultIsSelected(), showCheckmark = getChipsToggleDefaultShowCheckmark(), onClick, children }, ref)=>{
    const concatenatedClassName = `${styles.toggleChip} ${size === 'small' ? styles.toggleChip_small : ''} ${showCheckmark ? styles.toggleChip_withCheckmark : ''} ${className}`.trim();
    return /*#__PURE__*/ jsxs("button", {
        ref: ref,
        type: 'button',
        id: id,
        disabled: disabled,
        className: concatenatedClassName,
        lang: lang,
        "data-testid": dataTestId,
        "aria-pressed": isSelected ? 'true' : 'false',
        onClick: onClick,
        children: [
            showCheckmark ? /*#__PURE__*/ jsx(Icon, {
                className: styles.icon,
                svgPath: isSelected ? CompletedSVGpath : CircleRingSVGpath,
                size: size
            }) : null,
            children
        ]
    });
});
ChipsToggle.displayName = 'ChipsToggle';

export { ChipsToggle, getChipDefaultSize, getChipsToggleDefaultIsSelected, getChipsToggleDefaultShowCheckmark };
